import { type FC } from "react";
import { GitBranchIcon } from "lucide-react";
import { SkeletonText } from "@/components/podkit/loading/Skeleton";
import type { PlainEnvironment } from "@/queries/environment-queries";
import { useBranch } from "@/hooks/use-branch";

export const GitBranch: FC<{ environment?: PlainEnvironment; failed: boolean }> = ({ environment, failed }) => {
    const branch = useBranch(environment);
    return (
        <div title={branch} className="flex min-w-6 flex-row items-center gap-2 text-base text-content-primary">
            <SkeletonText size="base" className="w-20" failed={failed} ready={Boolean(branch)}>
                <GitBranchIcon className="inline size-4 flex-none" />
                <span className="min-w-1 shrink truncate whitespace-nowrap" translate="no">
                    {branch}
                </span>
            </SkeletonText>
        </div>
    );
};
